(function () {
  "use strict";

  if (!window.ecoflowIsHomePage) return;

  var doc = document;
  var deferredHeaderRequest;

  function ready(callback) {
    if (doc.readyState === "loading") {
      doc.addEventListener("DOMContentLoaded", callback, { once: true });
      return;
    }
    callback();
  }

  function requestFullBundle(reason, delay) {
    if (typeof window.ecoflowLoadHomeDeferredBundle === "function") {
      window.ecoflowLoadHomeDeferredBundle(reason || "critical-interaction", {
        delay: delay
      });
    }
  }

  function getBundleDelay(reason) {
    if (reason === "search-submit") return 0;
    if (reason && reason.indexOf("mobile") === 0) return 1000;
    if (reason === "cart-drawer" || reason === "search") return 900;
    return 1200;
  }

  function deferBundleLoad(reason) {
    requestFullBundle(reason || "deferred-interaction", getBundleDelay(reason));
  }

  function isFullBundleReady() {
    return window.ecoflowHomeFullBundleLoaded === true;
  }

  function query(selector, root) {
    return (root || doc).querySelector(selector);
  }

  function queryAll(selector, root) {
    return Array.prototype.slice.call((root || doc).querySelectorAll(selector));
  }

  function hydrateLazyMedia(root) {
    if (!root) return;

    queryAll("source[data-srcset], source[data-home-slide-srcset]", root).forEach(function (source) {
      var dataSrcset = source.getAttribute("data-srcset") || source.getAttribute("data-home-slide-srcset");
      if (!dataSrcset) return;
      source.setAttribute("srcset", dataSrcset);
      source.removeAttribute("data-srcset");
      source.removeAttribute("data-home-slide-srcset");
    });

    queryAll("img[data-src], img[data-srcset], img[data-home-slide-src], img[data-home-slide-srcset]", root).forEach(function (image) {
      var dataSrc = image.getAttribute("data-src") || image.getAttribute("data-home-slide-src");
      var dataSrcset = image.getAttribute("data-srcset") || image.getAttribute("data-home-slide-srcset");

      if (dataSrcset) {
        image.setAttribute("srcset", dataSrcset);
        image.removeAttribute("data-srcset");
        image.removeAttribute("data-home-slide-srcset");
      }

      if (dataSrc) {
        image.setAttribute("src", dataSrc);
        image.removeAttribute("data-src");
        image.removeAttribute("data-home-slide-src");
      }

      image.classList.remove("lazyload");
      image.classList.add("lazyloaded");
    });
  }

  function fetchDeferredHeader(url) {
    if (!deferredHeaderRequest) {
      deferredHeaderRequest = window.fetch(url, { credentials: "same-origin" })
        .then(function (response) {
          if (!response.ok) throw new Error("Deferred mega menu request failed");
          return response.text();
        })
        .then(function (html) {
          return new window.DOMParser().parseFromString(html, "text/html");
        });
    }

    return deferredHeaderRequest;
  }

  function ensureDeferredMegaMenu(item) {
    var slot = query("[data-ecoflow-deferred-mega-panel]", item);
    if (!slot || slot.dataset.loaded === "true") {
      return Promise.resolve(true);
    }

    if (slot.loadingPromise) return slot.loadingPromise;

    item.dataset.ecoflowDeferredMegaLoading = "true";
    slot.setAttribute("aria-busy", "true");
    slot.loadingPromise = fetchDeferredHeader(slot.getAttribute("data-section-url"))
      .then(function (responseDoc) {
        var source;

        if (item.getAttribute("data-ecoflow-deferred-mega-menu") === "desktop") {
          var menuIndex = slot.getAttribute("data-menu-index");
          var sourceItem = query('.nav-bar__item[data-menu-index="' + menuIndex + '"]', responseDoc);
          source = sourceItem && query(".mega-menu", sourceItem);
        } else {
          var title = slot.getAttribute("data-menu-title");
          var sourceButton = queryAll(".mobile-nav .megamenu-btn", responseDoc).find(function (button) {
            return button.getAttribute("data-target") === title;
          });
          source = sourceButton && query(".mobile-nav__dropdown", sourceButton.parentElement);
        }

        if (!source) throw new Error("Deferred mega menu response is missing panel");

        var panel = source.cloneNode(true);
        hydrateLazyMedia(panel);
        slot.dataset.loaded = "true";
        slot.replaceWith(panel);
        item.dataset.ecoflowDeferredMegaLoaded = "true";
        item.dataset.ecoflowDeferredMegaLoading = "false";
        return true;
      })
      .catch(function () {
        slot.setAttribute("aria-busy", "false");
        slot.dataset.loadError = "true";
        slot.loadingPromise = null;
        item.dataset.ecoflowDeferredMegaLoading = "false";
        return false;
      });

    return slot.loadingPromise;
  }

  function initDeferredMegaMenus() {
    function setDesktopDeferredItemOpenState(targetItem, isOpen) {
      targetItem.classList.toggle("visible", isOpen);
      var link = query(".nav-bar__link", targetItem);
      var overlay = query(".mega_menu_overlay");
      if (link) {
        link.classList.toggle("active", isOpen);
        link.setAttribute("aria-expanded", isOpen ? "true" : "false");
      }
      if (overlay) {
        var hasVisibleMenu = queryAll('[data-ecoflow-deferred-mega-menu="desktop"].visible').length > 0;
        overlay.style.display = hasVisibleMenu ? "block" : "none";
      }
    }

    function closeOtherDeferredDesktopItems(currentItem) {
      queryAll('[data-ecoflow-deferred-mega-menu="desktop"]').forEach(function (candidate) {
        if (candidate === currentItem) return;
        candidate.dataset.ecoflowDeferredHoverIntent = "false";
        setDesktopDeferredItemOpenState(candidate, false);
      });
    }

    queryAll('[data-ecoflow-deferred-mega-menu="desktop"]').forEach(function (item) {
      function openDesktopDeferredItem() {
        closeOtherDeferredDesktopItems(item);
        setDesktopDeferredItemOpenState(item, true);
      }

      function closeDesktopDeferredItem() {
        setDesktopDeferredItemOpenState(item, false);
      }

      function openAfterLoad() {
        item.dataset.ecoflowDeferredHoverIntent = "true";
        closeOtherDeferredDesktopItems(item);
        ensureDeferredMegaMenu(item).then(function (loaded) {
          if (!loaded) return;
          var hasFocusWithin = item.contains(doc.activeElement);
          if (item.dataset.ecoflowDeferredHoverIntent !== "true" && !hasFocusWithin) return;
          openDesktopDeferredItem();
          requestFullBundle("desktop-mega-menu");
        });
      }

      item.addEventListener("mouseenter", openAfterLoad);
      item.addEventListener("focusin", openAfterLoad);
      item.addEventListener("mouseleave", function () {
        if (isFullBundleReady()) return;
        item.dataset.ecoflowDeferredHoverIntent = "false";
        closeDesktopDeferredItem();
      });
      item.addEventListener("focusout", function (event) {
        if (isFullBundleReady()) return;
        var nextTarget = event.relatedTarget;
        if (nextTarget && item.contains(nextTarget)) return;
        item.dataset.ecoflowDeferredHoverIntent = "false";
        closeDesktopDeferredItem();
      });
    });
  }

  function closeSearch() {
    var searchButton = query(".header-search-button.active");
    var searchDropdown = query(".search-form__container.show_form");
    var overlay = query(".mega_menu_overlay");

    if (searchButton) searchButton.classList.remove("active");
    if (searchDropdown) {
      searchDropdown.classList.remove("show_form");
      var predictive = query(".predictive-search-wrapper", searchDropdown);
      if (predictive) predictive.classList.remove("visible");
    }

    doc.body.classList.remove("show_overlay");
    doc.body.classList.remove("show_search_overlay");
    if (overlay) overlay.style.display = "none";
  }

  function closeCartDrawer() {
    var drawer = query("#sidebar-cart");
    if (!drawer) return;
    drawer.classList.remove("show");
    doc.body.classList.remove("show_overlay");
  }

  function initHeader() {
    var body = doc.body;
    var header = query(".site-header");
    var mobileNavToggle = query(".js-mobile-nav-toggle");
    var mobileNavContainer = query(".mobile-nav-wrapper");
    var mobileNav = query("#MobileNav");
    var mobileOverlay = query(".mobile_menu_overlay");
    var megaOverlay = query(".mega_menu_overlay");

    function closeMobileNav() {
      if (!mobileNavToggle || !mobileNavContainer) return;

      queryAll(".js-toggle-submenu.is-active").forEach(function (element) {
        element.classList.remove("is-active");
        if (element.parentElement) {
          element.parentElement.classList.remove("is-active");
        }
      });

      mobileNavContainer.classList.remove("js-menu--is-open");
      body.classList.remove("js-menu--is-open");
      mobileNavToggle.classList.add("mobile-nav--open");
      mobileNavToggle.classList.remove("mobile-nav--close");
      mobileNavToggle.setAttribute("aria-expanded", "false");
    }

    function openMobileNav() {
      if (!mobileNavToggle || !mobileNavContainer) return;

      closeSearch();
      closeCartDrawer();

      var headerHeight = header ? header.offsetHeight : 0;
      mobileNavContainer.classList.add("js-menu--is-open");
      body.classList.add("js-menu--is-open");
      mobileNavToggle.classList.add("mobile-nav--close");
      mobileNavToggle.classList.remove("mobile-nav--open");
      mobileNavToggle.setAttribute("aria-expanded", "true");
      mobileNavContainer.style.top = Math.max(0, headerHeight - 2) + "px";

      if (mobileNav) {
        window.requestAnimationFrame(function () {
          var mobileNavHeight = mobileNav.offsetHeight;
          queryAll(".mobile-nav__dropdown", mobileNav).forEach(function (dropdown) {
            mobileNavHeight = Math.max(mobileNavHeight, dropdown.offsetHeight);
          });
          if (mobileNavHeight) mobileNav.style.minHeight = mobileNavHeight + "px";
        });
      }
    }

    if (mobileNavToggle && mobileNavContainer) {
      mobileNavToggle.addEventListener("click", function (event) {
        if (isFullBundleReady()) return;
        event.preventDefault();

        if (mobileNavContainer.classList.contains("js-menu--is-open")) {
          closeMobileNav();
        } else {
          openMobileNav();
        }

        deferBundleLoad("mobile-menu");
      });
    }

    if (mobileOverlay) {
      mobileOverlay.addEventListener("click", function () {
        if (isFullBundleReady()) return;
        closeMobileNav();
      });
    }

    queryAll(".js-toggle-submenu").forEach(function (button) {
      function toggleButtonState() {
        var expanded = button.getAttribute("aria-expanded") === "true";
        var nextExpanded = !expanded;
        button.setAttribute("aria-expanded", nextExpanded ? "true" : "false");
        button.classList.toggle("is-active", nextExpanded);
        if (button.parentElement) {
          button.parentElement.classList.toggle("is-active", nextExpanded);
        }
      }

      button.addEventListener("click", function (event) {
        if (isFullBundleReady()) return;
        event.preventDefault();
        var deferredItem = button.closest("[data-ecoflow-deferred-mega-menu]");
        if (deferredItem) {
          if (deferredItem.dataset.ecoflowDeferredMegaLoading === "true") return;
          ensureDeferredMegaMenu(deferredItem).then(function (loaded) {
            if (!loaded) return;
            toggleButtonState();
            deferBundleLoad("mobile-deferred-mega-menu");
          });
        } else {
          toggleButtonState();
          deferBundleLoad("mobile-submenu");
        }
      });
    });

    queryAll(".header-search-button").forEach(function (button) {
      button.addEventListener("click", function (event) {
        if (isFullBundleReady()) return;
        event.preventDefault();
        closeMobileNav();
        closeCartDrawer();

        var searchRoot = button.closest(".search-bar__interior");
        var searchDropdown = searchRoot ? query(".search-form__container", searchRoot) : null;
        var predictive = searchDropdown ? query(".predictive-search-wrapper", searchDropdown) : null;
        var willOpen = searchDropdown && !button.classList.contains("active");

        closeSearch();

        if (willOpen) {
          searchDropdown.classList.add("show_form");
          if (predictive) predictive.classList.add("visible");
          button.classList.add("active");
          body.classList.add("show_overlay");
          body.classList.add("show_search_overlay");
          if (megaOverlay) megaOverlay.style.display = "block";
        }

        deferBundleLoad("search");
      });
    });

    queryAll(".search-close").forEach(function (button) {
      button.addEventListener("click", function (event) {
        if (isFullBundleReady()) return;
        event.preventDefault();
        closeSearch();
      });
    });

    queryAll(".search-button__submit").forEach(function (button) {
      button.addEventListener("click", function () {
        deferBundleLoad("search-submit");
      });
    });

    queryAll("[data-header-login-trigger]").forEach(function (button) {
      button.addEventListener("click", function (event) {
        var dialog = query("#login-popup-dialog");

        event.preventDefault();

        if (dialog && typeof dialog.showModal === "function") {
          if (!dialog.open) dialog.showModal();
          deferBundleLoad("header-login");
          return;
        }

        if (typeof window.openLoginPopupDialog === "function") {
          window.openLoginPopupDialog();
        }

        deferBundleLoad("header-login");
      });
    });

    var headerCart = query("#HeaderCart");
    var cartDrawer = query("#sidebar-cart");
    if (headerCart && cartDrawer) {
      headerCart.addEventListener("click", function (event) {
        if (isFullBundleReady()) return;
        event.preventDefault();
        closeSearch();
        closeMobileNav();
        cartDrawer.classList.add("show");
        body.classList.add("show_overlay");
        deferBundleLoad("cart-drawer");
      });
    }

    queryAll('[data-action="close-drawer"][data-drawer-id="sidebar-cart"]').forEach(function (button) {
      button.addEventListener("click", function (event) {
        if (isFullBundleReady()) return;
        event.preventDefault();
        closeCartDrawer();
      });
    });

    doc.addEventListener("keyup", function (event) {
      if (event.key !== "Escape" && event.keyCode !== 27) return;
      if (isFullBundleReady()) return;
      closeSearch();
      closeCartDrawer();
      closeMobileNav();
    });
  }

  function initSlideshow() {
    queryAll('[data-section-type="slideshow-section"]').forEach(function (section) {
      var slides = queryAll("[data-slider-item]", section);
      var buttons = queryAll("[data-slider-button]", section);
      if (slides.length <= 1 || !buttons.length) return;

      var activeIndex = slides.findIndex(function (slide) {
        return slide.classList.contains("slideshow__slide--active");
      });
      if (activeIndex < 0) activeIndex = 0;

      function hydrateSlideMedia(slide) {
        if (!slide) return;

        queryAll("source[data-home-slide-srcset], source[data-srcset]", slide).forEach(function (source) {
          var dataSrcset = source.getAttribute("data-home-slide-srcset") || source.getAttribute("data-srcset");
          source.setAttribute("srcset", dataSrcset);
          source.removeAttribute("data-home-slide-srcset");
          source.removeAttribute("data-srcset");
        });

        queryAll("img[data-home-slide-src], img[data-home-slide-srcset], img[data-src], img[data-srcset]", slide).forEach(function (image) {
          var dataSrc = image.getAttribute("data-home-slide-src") || image.getAttribute("data-src");
          var dataSrcset = image.getAttribute("data-home-slide-srcset") || image.getAttribute("data-srcset");

          if (dataSrcset) {
            image.setAttribute("srcset", dataSrcset);
            image.removeAttribute("data-home-slide-srcset");
            image.removeAttribute("data-srcset");
          }

          if (dataSrc) {
            image.setAttribute("src", dataSrc);
            image.removeAttribute("data-home-slide-src");
            image.removeAttribute("data-src");
          }

          image.classList.remove("lazyload");
          image.classList.add("lazyloaded");
        });
      }

      function setSlide(index) {
        activeIndex = (index + slides.length) % slides.length;
        hydrateSlideMedia(slides[activeIndex]);
        slides.forEach(function (slide, slideIndex) {
          slide.classList.toggle("slideshow__slide--active", slideIndex === activeIndex);
        });
        section.dispatchEvent(new CustomEvent("slider_slide_changed", {
          detail: activeIndex
        }));
      }

      hydrateSlideMedia(slides[activeIndex]);

      buttons.forEach(function (button) {
        button.addEventListener("click", function (event) {
          if (isFullBundleReady() && section.querySelector(".flickity-enabled")) return;
          event.preventDefault();
          setSlide(button.hasAttribute("data-slider-button-next") ? activeIndex + 1 : activeIndex - 1);
          deferBundleLoad("slideshow");
        });
      });
    });
  }

  function initDeferredSubmenus() {
    var submenus = queryAll("[data-home-deferred-submenu]");
    if (!submenus.length) return;

    function revealSubmenus() {
      submenus.forEach(function (submenu) {
        if (submenu.dataset.homeDeferredSubmenuReady === "true") return;
        var placeholder = query("[data-home-deferred-submenu-placeholder]", submenu);
        var content = query("[data-home-deferred-submenu-content]", submenu);
        if (!content) return;

        content.hidden = false;
        hydrateLazyMedia(content);
        if (placeholder) placeholder.hidden = true;
        submenu.dataset.homeDeferredSubmenuReady = "true";
        submenu.removeAttribute("aria-busy");
      });
    }

    function scheduleReveal(delay) {
      window.setTimeout(function () {
        if ("requestIdleCallback" in window) {
          window.requestIdleCallback(revealSubmenus, { timeout: 2500 });
        } else {
          revealSubmenus();
        }
      }, delay);
    }

    function revealAfterInteraction() {
      ["pointerdown", "keydown", "touchstart", "scroll"].forEach(function (eventName) {
        window.removeEventListener(eventName, revealAfterInteraction, true);
      });
      scheduleReveal(800);
    }

    ["pointerdown", "keydown", "touchstart", "scroll"].forEach(function (eventName) {
      window.addEventListener(eventName, revealAfterInteraction, { once: true, passive: true, capture: true });
    });

    if (doc.readyState === "complete") {
      scheduleReveal(4500);
    } else {
      window.addEventListener("load", function () {
        scheduleReveal(4500);
      }, { once: true });
    }
  }

  function initDeferredHoverProductImages() {
    queryAll("[data-home-hover-card]").forEach(function (card) {
      function hydrateHoverImages() {
        queryAll("img[data-home-hover-image]", card).forEach(function (image) {
          if (image.dataset.homeHoverImageLoaded === "true") return;

          var dataSrc = image.getAttribute("data-home-hover-src");
          var dataSrcset = image.getAttribute("data-home-hover-srcset");

          if (dataSrcset) {
            image.setAttribute("srcset", dataSrcset);
          }

          if (dataSrc) {
            image.setAttribute("src", dataSrc);
          }

          image.dataset.homeHoverImageLoaded = "true";
          image.removeAttribute("data-home-hover-src");
          image.removeAttribute("data-home-hover-srcset");
          image.removeAttribute("data-home-hover-image");
        });
      }

      card.addEventListener("mouseenter", hydrateHoverImages, { once: true });
      card.addEventListener("focusin", hydrateHoverImages, { once: true });
    });
  }

  function initEmailSubscriptionFallback() {
    var popup = query("#email-subscription-popup");
    if (!popup) return;

    var wrapper = query(".email-subscription-popup__wrapper", popup);
    var trigger = query(".email-subscription-popup__trigger-image-wrapper", popup);
    var triggerClose = query(".email-subscription-popup__trigger-close", popup);
    var bodyClose = query(".email-subscription-popup__body-close-button", popup);
    var delaySeconds = Number(popup.getAttribute("data-popup-delay-seconds")) || 0;
    var delayDays = Number(popup.getAttribute("data-popup-delay-days")) || 0;
    var autoShow = popup.getAttribute("data-auto-show-popup") === "true";
    var delayKey = window.location.hostname + "_email_subscription_popup_delay_date";
    var createdAt = Number(popup.getAttribute("data-popup-created-at")) || 0;

    function isAlpineReady() {
      return !!(
        window.Alpine &&
        popup._x_dataStack &&
        popup._x_dataStack.some(function (data) {
          return data && typeof data.togglePopup === "function";
        })
      );
    }

    function setDelayDate() {
      if (!delayDays) return;
      var targetDay = new Date();
      targetDay.setHours(0, 0, 0, 0);
      targetDay.setDate(new Date().getDate() + delayDays);
      try {
        window.localStorage.setItem(delayKey, targetDay);
      } catch (error) {}
    }

    function isDelayDateValid() {
      try {
        var delayDate = window.localStorage.getItem(delayKey);
        return Date.now() < new Date(delayDate).getTime();
      } catch (error) {
        return false;
      }
    }

    function showTrigger() {
      popup.removeAttribute("x-cloak");
      popup.style.display = "";
      popup.dataset.homeCriticalTriggerHidden = "false";
      if (wrapper && popup.dataset.homeCriticalPopupOpen !== "true") {
        wrapper.style.display = "none";
      }
    }

    function hideTrigger() {
      popup.dataset.homeCriticalTriggerHidden = "true";
      popup.style.display = "none";
    }

    function openPopup() {
      if (!wrapper) return;
      var body = query(".email-subscription-popup__body", popup);
      var subscription = query(".email-subscription-popup__subscription", popup);
      showTrigger();
      popup.dataset.homeCriticalPopupOpen = "true";
      if (body) {
        body.classList.add("email-subscription-popup__body--subscrption");
      }
      if (subscription && !isAlpineReady()) {
        subscription.style.display = "";
      }
      wrapper.style.display = "";
      requestFullBundle("email-popup");
    }

    function closePopup() {
      if (!wrapper) return;
      popup.dataset.homeCriticalPopupOpen = "false";
      wrapper.style.display = "none";
      setDelayDate();
    }

    var shouldAutoOpen = autoShow && !isDelayDateValid();

    if (shouldAutoOpen) {
      showTrigger();
      if (wrapper) {
        wrapper.style.display = "none";
      }
      requestFullBundle("email-popup");
    } else {
      showTrigger();
    }

    if (trigger) {
      trigger.addEventListener("click", function (event) {
        if (isAlpineReady()) return;
        event.preventDefault();
        openPopup();
      });
    }

    if (triggerClose) {
      triggerClose.addEventListener("click", function (event) {
        if (isAlpineReady()) return;
        event.preventDefault();
        hideTrigger();
      });
    }

    if (bodyClose) {
      bodyClose.addEventListener("click", function (event) {
        if (isAlpineReady()) return;
        event.preventDefault();
        closePopup();
      });
    }

    queryAll(".email-subscription-popup__input, .email-subscription-popup__button--subscription", popup).forEach(function (element) {
      element.addEventListener("focus", function () {
        requestFullBundle("email-popup-form");
      });
      element.addEventListener("click", function () {
        requestFullBundle("email-popup-form");
      });
    });

    if (shouldAutoOpen) {
      var elapsed = window.performance && typeof window.performance.now === "function"
        ? window.performance.now() - createdAt
        : 0;
      var remainingDelay = Math.max(0, delaySeconds * 1000 - elapsed);
      window.setTimeout(function () {
        if (!isAlpineReady() && !isDelayDateValid()) {
          openPopup();
        }
      }, remainingDelay);
    }
  }

  ready(function () {
    initHeader();
    initDeferredMegaMenus();
    initSlideshow();
    initDeferredSubmenus();
    initDeferredHoverProductImages();
    initEmailSubscriptionFallback();
    doc.documentElement.classList.add("home-critical-js-ready");
  });
})();
